import httpService from "../../Service/httpService";

const controller = "HojaEnfermeria";


export const getPacientesSesion = async (id, idEnf, fecha, hora) => {
	const res = await httpService.get(`/${controller}/getPacientesSesion/${id}/${idEnf}/${fecha}/${hora}`);
	return res.data;
};

export const getDatospaciente = async (id, idPac, fecha, hora) => {
	const res = await httpService.get(`/${controller}/getDatosPaciente/${id}/${idPac}/${fecha}/${hora}`);
	return res.data;
};

export const getDatospacienteView = async (id, idSesion) => {
	const res = await httpService.get(`/${controller}/getDatosPacienteView/${id}/${idSesion}`);
	return res.data;
};

export const getVerificaProc = async (id, idHojaEnf) => {
	const res = await httpService.get(`/${controller}/getVerificaProc/${id}/${idHojaEnf}`);
	return res.data;
};

export const getAccesoVascular = async (id) => {
	const res = await httpService.get(`/${controller}/getAccesoVascular/${id}`);
	return res.data;
};


export const getDataFiltro = async (id, idFiltro) => {
	const res = await httpService.get(`/${controller}/getDataFiltro/${id}/${idFiltro}`);
	return res.data;
};

export const getNumSesionesSem = async (id, idPac, idAsigna) => {
	const res = await httpService.get(`/${controller}/getNumSesionesSem/${id}/${idPac}/${idAsigna}`);
	return res.data;
};

export const getHoraActual = async () => {
	const res = await httpService.get(`/${controller}/getHoraActual`);
	return res.data;
};

export const getHojaEnfermeria = async (id, idSesion) => {
	const res = await httpService.get(`/${controller}/getHojaEnfermeria/${id}/${idSesion}`);
	return res.data;
};

export const getAntiCoagulantes = async (id) => {
	const res = await httpService.get(`/${controller}/getAntiCoagulantes/${id}`);
	return res.data;
};

export const getSeguimientos = async (id, idHoja) => {
	const res = await httpService.get(`/${controller}/getSeguimientos/${id}/${idHoja}`);
	return res.data;
};

export const getFiltroAsignadoSesion = async (id, idPac) => {
	const res = await httpService.get(`/${controller}/getFiltroAsignadoSesion/${id}/${idPac}`);
	return res.data;
};

export const getExisteAsignacion = async (id, idPac) => {
	const res = await httpService.get(`/${controller}/getExisteAsignacion/${id}/${idPac}`);
	return res.data;
};

export const getValidaCierre = async (id, idHoja) => {
	const res = await httpService.get(`/${controller}/getValidaCierre/${id}/${idHoja}`);
	return res.data;
};

export const getSeguimientosHoja = async (id, idHoja, hora) => {
	const res = await httpService.get(`/${controller}/getSeguimientosHoja/${id}/${idHoja}/${hora}`);
	return res.data;
};

export const getHojasPaciente = async (id, idPac) => {
	const res = await httpService.get(`/${controller}/getHojasPaciente/${id}/${idPac}`);
	return res.data;
};


export const iniciaHojaEnf = async (data) => {
  //   const userData = getDecodedToken();
  const res = await httpService.post(`/${controller}/iniciaHojaEnf`, {
	...data,
  });
  return res;
};

export const saveCampoHoja = async (data) => {
  //   const userData = getDecodedToken();
  const res = await httpService.post(`/${controller}/saveCampoHoja`, {
	...data,
  });
  return res;
};


export const saveSeguimiento = async (data) => {
  //   const userData = getDecodedToken();
  const res = await httpService.post(`/${controller}/saveSeguimiento`, {
	...data,
  });
  return res;
};


export const saveVerificaPre = async (data) => {
  //   const userData = getDecodedToken();
  const res = await httpService.post(`/${controller}/saveVerificaPre`, {
	...data,
  });
  return res;
};


//saveHoraAplica
export const saveHoraAplica = async (data) => {
  //   const userData = getDecodedToken();
  const res = await httpService.post(`/${controller}/saveHoraAplica`, {
	...data,
  });
  return res;
};

export const saveFirmaHojaEnf = async (data) => {
  //   const userData = getDecodedToken();
  const res = await httpService.post(`/${controller}/saveFirmaHojaEnf`, {
	...data,
  });
  return res;
};







